export const administration_types = {
  1: 'Clinician-administered',
  2: 'Self-administered',
  3: 'Parent/Caregiver-administered',
  4: 'Teacher-administered',
  5: 'Caregiver-Rated',
  6: 'Agency Worker-Rated',
  7: 'Observer-administered'
};

export const courseSectionTypeEnum = {
  ASSESSMENT: 0,
  SLIDES: 1,
  ACTIVITY: 2,
  QUIZ: 3,
  VIDEO: 4
};

export const activityTypes = {
  SELF_ASSESSMENT: 0,
  COURSE: 1,
  MEETING: 2,
  HELPLINE: 3
};

export const statusEnum = {
  INITIATED: 0,
  COMPLETED: 1,
  EXPIRED: 2,
  CANCELLED: 3
};
